import moment from "moment/moment";

export function formatToUtc(date) {
	return moment(date).utc(true).format();
}
